import { defineStore } from 'pinia'
import { authApi } from '../services/api'
import type { User } from '../types/api'

interface UserState {
  currentUser: User | null
  loading: boolean
  is2FAEnabled: boolean
}

export const useUserStore = defineStore('user', {
  state: (): UserState => ({
    currentUser: null,
    loading: false,
    is2FAEnabled: false,
  }),

  getters: {
    userName: (state) => {
      if (!state.currentUser) return ''
      const employee = state.currentUser.employee
      if (employee?.first_name && employee?.last_name) {
        return `${employee.first_name} ${employee.last_name}`
      }
      return state.currentUser.username
    },

    email: (state) => state.currentUser?.email || '',

    memberSince: (state) => {
      if (!state.currentUser?.created_at) return ''
      const date = new Date(state.currentUser.created_at)
      return date.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' })
    },

    userRole: (state) => {
      if (!state.currentUser?.roles || state.currentUser.roles.length === 0) return ''
      return state.currentUser.roles[0].display_name || state.currentUser.roles[0].name
    },

    employeeInfo: (state) => state.currentUser?.employee || null,
  },

  actions: {
    async fetchCurrentUser() {
      this.loading = true
      try {
        const user = await authApi.me()
        this.currentUser = user
      } catch (error) {
        throw error
      } finally {
        this.loading = false
      }
    },

    toggle2FA() {
      this.is2FAEnabled = !this.is2FAEnabled
    },

    changeUserName(userName: string) {
      if (this.currentUser?.employee) {
        // Dividir el nombre completo en first_name y last_name
        const parts = userName.split(' ')
        this.currentUser.employee.first_name = parts[0] || ''
        this.currentUser.employee.last_name = parts.slice(1).join(' ') || ''
      }
    },

    clearUser() {
      this.currentUser = null
      this.is2FAEnabled = false
    },
  },
})
